import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService } from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-input-email-config',
  templateUrl: './input-email-config.component.html',
  styleUrls: ['./input-email-config.component.scss'],
})
export class AtwInputEmailConfig implements OnInit {
  isCollapsed: boolean = false;
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {};
  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = ''; // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  fonts = []; // danh sách font chữ
  customize = [];

  backgroundColor: any = []; //danh sách màu nền.
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
    },
    {
      name: 'dashed',
      img_border: 'https://static.thenounproject.com/png/2264023-200.png',
    },
    {
      name: 'dotted',
      img_border: 'https://static.thenounproject.com/png/2449182-200.png',
    },
  ];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  effect_hover = []; // danh sách hiệu ứng khi hover
  effect_hover_data: any = {}; // data danh sách hiệu ứng
  classUpdates: any = {
    'input-email': {
      position: 'relative',
    },
    'input-email__error': {
      'background-color': 'rgba(241, 241, 241, 0)',
      width: 'auto',
      'padding-top': "0px",
      'padding-bottom': "0px",
      'padding-left': "0px",
      'padding-right': "0px",
      'border-top-width': "0px",
      'border-bottom-width': "0px",
      'border-left-width': "0px",
      'border-right-width': "0px",
      'border-style': "solid",
      'border-color': "rgba(255, 255, 255, 0)",
      'border-top-left-radius': "0px",
      'border-top-right-radius': "0px",
      'border-bottom-right-radius': "0px",
      'border-bottom-left-radius': "0px",
      'box-shadow': "none",
    }
  };
  configUpdates: any = {
    "error_arrow": {
      top: "-18px",
      left: "10%",
      display: "none",
      border_width: "10px",
      is_same_color: true,
      border_bottom_color: "#f1f1f1",
    },
    "error-box-shadow": {
      "is_box_shadow": false,
      "property_box_shadow": {
          "type": "outset",
          "h-offset": 2,
          "v-offset": 2,
          "blur": 2,
          "spread": 0,
          "color": "#000000"
      }
    }
  }
  staticdataUpdates: any = {
    "datasetArray": []
  };
  objectsArrayGetData: any = [];
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) {}
  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };
  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/input.json'),
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json'),
    ]).subscribe(([effects, background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  
    for (const key in this.classUpdates) {
      if (!this.class.hasOwnProperty(key)) {
        this.class[key] = this.classUpdates[key];
      } else {
        for (const key2 in this.classUpdates[key]) {
          if (!this.class[key].hasOwnProperty(key2)) {
            this.class[key][key2] = this.classUpdates[key][key2];
          }
        }
      }
    }

    for (const key in this.configUpdates) {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.configUpdates[key];
      } else {
        for (const key2 in this.configUpdates[key]) {
          if (!this.config[key].hasOwnProperty(key2)) {
            this.config[key][key2] = this.configUpdates[key][key2];
          }
        }
      }
    }

    for (const key in this.staticdataUpdates) {
      if (!this.staticdata.hasOwnProperty(key)) {
        this.staticdata[key] = this.staticdataUpdates[key];
      } else {
        for (const key2 in this.staticdataUpdates[key]) {
          if (!this.staticdata[key].hasOwnProperty(key2)) {
            this.staticdata[key][key2] = this.staticdataUpdates[key][key2];
          }
        }
      }
    }

    this.vhQueryAutoWeb.getObjects_byFields({ component: { $in: ['AtwButtonPayment', 'AtwButtonAddToCart', 'AtwButtonConfirmOrder'] } }, {}, {}, 0)
      .then((objects) => {
        this.objectsArrayGetData = objects;
      });
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  changeWidthOfError(event: any) {
    this.class['input-email__error']['width'] = event ? '100%' : 'auto';
    if (event && this.class['input-email']['position'] !== 'relative') {
      this.class['input-email']['position'] = 'relative';
    }
    this.updateClass()
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['input-email__boundary'].background =
        'linear-gradient(' +
        this.config['background-color']['gradient_arr'] +
        ')';
    } else {
      this.class['input-email__boundary'].background =
        this.class['input-email__boundary']['background'];
    }
    this.updateObject();
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {});
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {});
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {});
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data =
      this.device === 'desktop'
        ? this.class['input-email__boundary']
        : this.class['input-email__boundary'];
    // Nối chuỗi màu + độ mờ (alpha) và lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${
      this.config['background-color']['value_range'] / 100
    })`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.device == 'desktop') {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr = this.config['background-color'].gradient_arr.map(
        (color) => {
          const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateBackgroundRgb();
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr = this.config['background-color'].gradient_arr.map(
        (color) => {
          // Tách các phần tử màu từ chuỗi rgba
          const parts = color.match(/(\d+(\.\d+)?)/g);
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateClass();
    }
  }
  /** Hàm này lấy giá trị màu nền của input color
   * @param event : trả về màu được chọn từ input color
   */
  updateColorInput(e) {
    const value_color = e.target.value;
    const data_desktop = this.class['input-email__boundary'];
    const data_mobile = this.class['input-email__boundary'];
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    if (this.device == 'desktop') {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${
        this.config['background-color']['value_range']
      })`;
      data_desktop.background_rgb = this.style_color;
      this.updateClass();
    } else {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${
        this.config['background-color']['value_range']
      })`;
      data_mobile.background_rgb = this.style_color;

      this.updateClass();
    }
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    // Lấy ra element màu được click từ tham số event trả về.
    var activeGradient = document.querySelector(
      '.container-color .active'
    ) as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    // Lấy giá trị màu được click từ tham số bgColor.
    //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
    const data_background =
      this.device == 'desktop'
        ? this.class['input-email__boundary']
        : this.class['input-email__boundary'];
    data_background.background = bgColor.bgColor;
    data_background.background = `rgba(${this.hexToRGB(
      data_background.background
    )}, ${this.config['background-color'].value_range})`;
    this.updateClass();
  }

  /** Xử lý border
   */
  toggleBorder(isActive) {
    if (this.device == 'desktop') {
      const active = this.class['input-email__boundary'];
      active.check_border = isActive;
      active.check_border_top = isActive;
      active.check_border_bottom = isActive;
      active.check_border_right = isActive;
      active.check_border_left = isActive;
    } else {
      const active = this.class['input-email__boundary'];
      active.check_border = isActive;
      active.check_border_top = isActive;
      active.check_border_bottom = isActive;
      active.check_border_right = isActive;
      active.check_border_left = isActive;
    }

    this.updateClass();
  }

  openbgGradient() {
    document.getElementById('input-gradient').click();
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb();
    }
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  handleRequired(value) {
    this.config['required'] = value;
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width)
      this.class['input-email__boundary']['width'] = event.width + 'px';
    if (event.height)
      this.class['input-email__boundary']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2]);
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
